import { forceResTimezone } from "src/utils/date/forceResTimezone";

export const PROMO_EXPIRATION_DATE = forceResTimezone(new Date(2025, 8, 30));

export const isPromoValid = (promoCode: string): boolean => {
  if (promoCode !== "a") {
    return false;
  }

  const today = forceResTimezone(new Date());
  return today <= PROMO_EXPIRATION_DATE;
};
